import _ from "lodash"

export function priceFormatter(value, fractionDigits = 2) {
    const numberValue = typeof value === 'string'
      ? _.toNumber(value.replace(/\./g, '').replace(',', '.'))
      : _.toNumber(value);

    if (!_.isFinite(numberValue)) return value;

    return numberValue.toLocaleString('tr-TR', { 
      minimumFractionDigits: fractionDigits, 
      maximumFractionDigits: fractionDigits 
    });
}